import type React from "react";

import RcSlider from "rc-slider";
import type { SliderProps as RcSliderProps } from "rc-slider";
import "rc-slider/assets/index.css";

import { cx, styled } from "simplydo/react/styled";

const StyledSlider = styled(RcSlider)`
  max-width: 80%;
  display: block;
  z-index: 0;
  margin: 20px auto;

  .rc-slider-rail {
    height: 8px;
  }
  .rc-slider-track {
    height: 8px;
  }
  .rc-slider-dot {
    display: none;
  }
  .rc-slider-mark-text {
    z-index: 5;
    user-select: none;
  }
  .rc-slider-handle {
    width: 30px;
    height: 30px;
    margin-top: -12px;
    z-index: 6;
    box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.1);
  }

  &.is-unset {
    .rc-slider-rail,
    .rc-slider-track {
      opacity: 0.25;
    }

    .rc-slider-track {
      background-color: transparent !important;
    }

    .rc-slider-handle {
      left: 50% !important;
    }
  }
`;

type SliderProps = {
  value: RcSliderProps["value"];
  min?: RcSliderProps["min"];
  max?: RcSliderProps["max"];
  steps?: RcSliderProps["step"];
  onChange?: NonNullable<RcSliderProps["onChange"]>;
  marks?: RcSliderProps["marks"];
  style?: React.CSSProperties;
};

const Slider = ({
  value,
  style,
  steps = 1,
  min = 1,
  max = 10,
  marks,
  ...props
}: SliderProps) => {
  return (
    <StyledSlider
      className={cx(value === undefined && "is-unset")}
      style={style}
      value={value}
      min={min !== undefined ? min : 1}
      max={max !== undefined ? max : 10}
      step={steps}
      marks={marks ?? { [min]: min, [max]: max }}
      {...props}
    />
  );
};

export default Slider;
